/* BY MAR — carte produit (ouverture de l'ajout rapide au doigt) + rafraichissement du tiroir panier Minimog
   quand une section ajoute au panier elle-meme (evenement « bm:cart:refresh »). Aucun prix n'est calcule ici. */
(function () {
  if (window.__bmCard) return;
  window.__bmCard = true;

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-bm-quick-toggle]');
    document.querySelectorAll('[data-bm-card].is-open').forEach(function (c) {
      if ((!t || c !== t.closest('[data-bm-card]')) && !c.contains(e.target)) {
        c.classList.remove('is-open');
        var b = c.querySelector('[data-bm-quick-toggle]');
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    });
    if (!t) return;
    e.preventDefault();
    var card = t.closest('[data-bm-card]');
    var on = !card.classList.contains('is-open');
    card.classList.toggle('is-open', on);
    t.setAttribute('aria-expanded', on ? 'true' : 'false');
  });

  // apres un ajout, le panneau se referme (le tiroir panier s'ouvre de son cote)
  document.addEventListener('submit', function (e) {
    var card = e.target.closest && e.target.closest('[data-bm-card]');
    if (card) setTimeout(function () { card.classList.remove('is-open'); }, 900);
  }, true);

  // Sections qui ajoutent elles-memes au panier (fetch /cart/add.js) : on recharge et ouvre le tiroir Minimog
  document.addEventListener('bm:cart:refresh', function () {
    var d = document.querySelector('m-cart-drawer');
    if (!d || typeof d.onCartDrawerUpdate !== 'function') { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; return; }
    d.onCartDrawerUpdate();
    if (typeof d.open === 'function') d.open();
  });
})();
